import {reactive} from "vue";

class MetaVendaColaboradorEvents {

    listenerMetaVendaColaboradorGravada = reactive({value: {metaVendaColaboradorId: ''}})
    listenerMetaVendaColaboradorRemovida = reactive({value: {metaVendaColaboradorId: ''}})

    emitMetaVendaColaboradorGravada(metaVendaColaboradorId: string) {
        this.listenerMetaVendaColaboradorGravada.value = {metaVendaColaboradorId: metaVendaColaboradorId}
    }

    emitMetaVendaColaboradorRemovida(metaVendaColaboradorId: string) {
        this.listenerMetaVendaColaboradorRemovida.value = {metaVendaColaboradorId: metaVendaColaboradorId}
    }


}

export default MetaVendaColaboradorEvents;